// Read-only helpers for restoring filter state from the URL query string on
// load. Kept as a factory over `route` (rather than module-level functions)
// since `route` is itself reactive and these need to read its current value.
export const createUrlQuery = (route) => {
  const queryStr = (key, fallback) => {
    const raw = route.query[key];
    return typeof raw === "string" && raw !== "" ? raw : fallback;
  };
  const queryList = (key) => {
    const raw = route.query[key];
    return typeof raw === "string" && raw !== "" ? raw.split(",") : [];
  };
  const queryNum = (key, fallback) => {
    const raw = route.query[key];
    const parsed = Number(raw);
    return typeof raw === "string" && raw !== "" && Number.isFinite(parsed) ? parsed : fallback;
  };
  return { queryStr, queryList, queryNum };
};
